import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ShopSearchParametersModalLauncherBlockConfig } from '@front-platform/content-builder';
import { shopSearchParametersModalLauncherBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import { ShopSearchParametersService } from '@core/services/shop-search-parameters/shop-search-parameters.service';

import { ShopSearchParametersModalComponent } from '@shared/modals/shop-search-parameters-modal/shop-search-parameters-modal.component';
export interface ShopSearchParametersModalLauncherBlockRuntimeConfig {}

export type ShopSearchParametersModalLauncherBlockConfigInput = Partial<
  Omit<
    ShopSearchParametersModalLauncherBlockConfig,
    keyof ShopSearchParametersModalLauncherBlockRuntimeConfig
  > &
    ShopSearchParametersModalLauncherBlockRuntimeConfig
>;
export type ShopSearchParametersModalLauncherBlockResolvedConfig = Omit<
  ShopSearchParametersModalLauncherBlockConfig,
  keyof ShopSearchParametersModalLauncherBlockRuntimeConfig
> &
  Partial<ShopSearchParametersModalLauncherBlockRuntimeConfig>;
export interface ShopSearchParametersModalLauncherBlockContract extends ConfigComponentContract<
  ShopSearchParametersModalLauncherBlockConfigInput,
  ShopSearchParametersModalLauncherBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-shop-search-parameters-modal-launcher-block',
  standalone: false,
})
export class ShopSearchParametersModalLauncherBlockComponent
  implements OnInit, OnDestroy, ShopSearchParametersModalLauncherBlockContract
{
  readonly config = input<ShopSearchParametersModalLauncherBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ShopSearchParametersModalLauncherBlockConfig,
    ShopSearchParametersModalLauncherBlockRuntimeConfig
  >(shopSearchParametersModalLauncherBlockResolveConfig, () => ({ config: this.config() }));
  get forceLaunch(): boolean {
    return this.resolvedConfig()['force_launch'] as unknown as boolean;
  }

  constructor(
    private readonly modalsService: ModalsService,
    private readonly shopSearchParametersService: ShopSearchParametersService,
  ) {}

  ngOnInit(): void {
    if (this.forceLaunch) {
      this.modalsService.open(ShopSearchParametersModalComponent.handle);
      return;
    }
    const parameters = this.shopSearchParametersService.getParameters();
    if (!parameters.is_distribution_mode_defined) {
      this.modalsService.open(ShopSearchParametersModalComponent.handle);
    }
  }

  ngOnDestroy(): void {
    this.modalsService.close(ShopSearchParametersModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ShopSearchParametersModalLauncherBlockComponent, {
  'keyAliases': {},
});
